<span (click)="openModal(addBAModal)" class="mdi mdi-border-color edit-size">
</span>
<ng-template #addBAModal>
    <div class="add-business-unit-administrator-modal">
        <div class="modal-body">
            <div class="head m-b-20">
                Appointment of an HR manager for <span class="font-weight-bold">{{ businessUnit.displayName }}</span>
            </div>
            <span class="row bu-admin-list-element" *ngFor="let buAdmin of selectedBusinessUnitAdministrators">
                <span class="col-10">{{buAdmin.name}} <i (click)="deleteFromSelected(buAdmin)" class="ti-close bu-admin-list-delete-element"></i></span>
            </span>
            <div class="m-t-10">
                <div class="caption">
                    <div class="mb-1">
                        Choose HR:
                    </div>
                    <ngx-select [items]="businessUnitAdministratorFilterOptions"
                                [multiple]="false"
                                optionValueField="id"
                                optionTextField="name"
                                (select)="assignBusinessUnitAdministrator($event)"
                                (removed)="unAssignBusinessUnitAdministrator($event)"
                                (typed)="searchBusinessUnitAdministratorByName($event)"
                                placeholder="Enter name"></ngx-select>
                </div>
                <div class="col-12 mt-2 p-0">
                    <span>
                        <input type="checkbox" id="checkboxhrDodal"
                               [(ngModel)]="isAssingnmentInheritateModal"
                               (change)="switchInheritation()">
                        <label for="checkboxhrDodal">
                            Inherit
                        </label>
                    </span>
                </div>
                <div class="btn-modal">
                    <span (click)="saveAssignmentChanges()">Save</span>
                    <span (click)="hideModal()">Cancel</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>